import { type OrderProduct } from '@repo/domain';

import { RouteName } from '@router/routeNames';

export interface PaymentSuccessContent {
  titleTranslationKey: string;
  messageTranslationKey: string;
  imageAltTranslationKey: string;
  redirectButtonTranslationKey: string;
  redirectToastTranslationKey: string;
  /** Where "go further" leads unless the payment says where it was started from. */
  routeName: RouteName;
}

export const PAYMENT_SUCCESS_CONTENT: Record<OrderProduct, PaymentSuccessContent> = {
  parkingSpotRental: {
    titleTranslationKey: 'reservations:success.title',
    messageTranslationKey: 'reservations:success.message',
    imageAltTranslationKey: 'reservations:success.image_alt',
    redirectButtonTranslationKey: 'reservations:success.redirect_button',
    redirectToastTranslationKey: 'reservations:success.redirect_toast',
    routeName: RouteName.ACCOUNT_RESERVATIONS,
  },
  parkingSpotRentalExtension: {
    titleTranslationKey: 'reservations:success.extension.title',
    messageTranslationKey: 'reservations:success.extension.message',
    imageAltTranslationKey: 'reservations:success.extension.image_alt',
    redirectButtonTranslationKey: 'reservations:success.redirect_button',
    redirectToastTranslationKey: 'reservations:success.redirect_toast',
    routeName: RouteName.ACCOUNT_RESERVATIONS,
  },
  balanceTopUp: {
    titleTranslationKey: 'reservations:success.top_up.title',
    messageTranslationKey: 'reservations:success.top_up.message',
    imageAltTranslationKey: 'reservations:success.top_up.image_alt',
    redirectButtonTranslationKey: 'reservations:success.top_up.redirect_button',
    redirectToastTranslationKey: 'reservations:success.top_up.redirect_toast',
    routeName: RouteName.ACCOUNT_WALLET,
  },
};

/** Used instead when the top-up was started from a payment the user should return to. */
export const PAYMENT_SUCCESS_RETURN_BUTTON_TRANSLATION_KEY = 'reservations:success.return_to_payment.redirect_button';
export const PAYMENT_SUCCESS_RETURN_TOAST_TRANSLATION_KEY = 'reservations:success.return_to_payment.redirect_toast';

export interface PaymentFailureContent {
  buttonTranslationKey: string;
  routeName: RouteName;
}

export const PAYMENT_FAILURE_CONTENT: Record<OrderProduct, PaymentFailureContent> = {
  parkingSpotRental: {
    buttonTranslationKey: 'reservations:failure.show_reservations',
    routeName: RouteName.ACCOUNT_RESERVATIONS,
  },
  parkingSpotRentalExtension: {
    buttonTranslationKey: 'reservations:failure.show_reservations',
    routeName: RouteName.ACCOUNT_RESERVATIONS,
  },
  balanceTopUp: {
    buttonTranslationKey: 'reservations:failure.top_up.show_wallet',
    routeName: RouteName.ACCOUNT_WALLET,
  },
};

export const PAYMENT_FAILURE_RETURN_BUTTON_TRANSLATION_KEY = 'reservations:failure.return_to_payment';
